<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <!-- 条形码输入框 -->
      <template v-slot:baseForm>
        <el-col :span="colSpan">
                                         <!-- 条形码 -->
          <el-form-item :label="$t('BarcodeConfiguration.Barcode')" prop="barCode">
            <BjInput
              v-model="queryParams.barCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>
      <!-- 删除、导入 按钮 -->
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:BusinessPurchaseSupplierIndex_ExcelImport
            type="primary"
            class="main-btn"
            @click="onImport"
            >
                          <!-- 导入 -->
            {{ $t('BarcodeConfiguration.Import') }}</el-button
          >
          <el-button
            v-permission:BusinessChannelPhysicalList_Delete
            type="primary"
            :disabled="tableOperationProp.notSelected"
            class="delete-btn"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[col.prop] }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <!-- {{ props.row }} -->                                                            <!-- 可用 -->
              <el-button v-if="props.row.status" type="primary" disabled>{{ $t('BarcodeConfiguration.available') }}</el-button>

                                                                          <!-- 已占用 -->
              <el-button v-else disabled type="info">{{ $t('BarcodeConfiguration.Unavailable') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 文件上传 -->                                                 <!-- 商品条形码模板 -->
    <BjExcelImportDialog ref="ExcelImport" :download-name="$t('BarcodeConfiguration.Product')" href="/商品条形码导入模板.xlsx" template-code="SGOO.BARCODE">
        {{ $t('BarcodeConfiguration.Excel') }}       <!-- Excel导入商品条形码规则说明： -->
      <br />
       1.{{ $t('BarcodeConfiguration.already') }}；  <!-- 如果系统已存在商品条形码资料，根据商品条形码更新数据，否则新建商品条形码信息 -->
      <br />
       2.{{ $t('BarcodeConfiguration.download') }}： <!-- 导入供应商信息模板，点击下载 -->
      <el-button type="primary" @click="onDownload()">{{ $t('BarcodeConfiguration.Product') }}<!-- 商品条形码模板 --></el-button>
      <br />
       3.{{ $t('BarcodeConfiguration.Importing') }}  <!-- 导入Excel格式必须带标题，红色标题为必填；Excel的列请设置为文本格式，不然可能会出现类型转换错误的问题 -->
      <br />
       4.{{ $t('BarcodeConfiguration.Supports') }}   <!-- 支持：csv、xls、xlsx格式，一次导入文件大小不能超过128MB，数据行不能超过6万行，如果超过，请分成多次导入。 -->
    </BjExcelImportDialog>

  </div>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import { goodsApi, channelApi, importApi } from '@/api';
import { downloadBlob } from '@/utils/index';
export default {
  name: 'SettingGoodsBarcodeIndex',
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: goodsApi.getQueryBarcode,
      // 查询参数
      queryParams: {
        barCode: null,
        deleteFlag: false
      },
      labelList: [
        // 条形码
        { label: this.$t('BarcodeConfiguration.Barcode'), prop: 'barCode', isCheck: true, disabled: false },
        // 状态
        { label: 'table.statusText', prop: 'bjTableAction', isCheck: true, disabled: true, width: 300 },
      ],
    };
  },
  created() {
  },
  methods: {
    onDownload() {
      const data = {templateCode: 'SGOO.BARCODE', tenantId: 0};
      importApi['exportExcelImportTemplateHeaders'](data).then(res => {
        downloadBlob(res, '条形码导入.xlsx');
      });
    },
    // 文件上传
    onImport() {
      this.$refs.ExcelImport.show();
    },

    /** 禁用 */
    onStatus(flag, row) {
                                      // 操作中，是否继续
      this.$confirm(this.$t('BarcodeConfiguration.Operation'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            objectVersionNumber: row.objectVersionNumber,
            flag: flag,
          });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.channelWarehouseStatus == true)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }

      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    // 禁用API
    operationApi(API_DATA) {
      channelApi.operationPhysicalShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      goodsApi.batchDeleteBarcode(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
